"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _offerStyles = require("../common/offer-styles.js");

var _baseReactComponents = require("@navinc/base-react-components");

var _useIsOverflowed = require("../util/use-is-overflowed");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FadeOut = _styledComponents["default"].div.withConfig({
  displayName: "FadeOut",
  componentId: "sc-1hsxa6c-0"
})(["height:64px;width:100%;background:linear-gradient(to bottom,transparent,", ");"], function (_ref) {
  var theme = _ref.theme;
  return theme.bubbleBlue100;
});

var ToggleMoreButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "ToggleMoreButton",
  componentId: "sc-1hsxa6c-1"
})(["background:", ";justify-content:center;width:100%;pointer-events:all;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.bubbleBlue100;
});

var OverflowControls = _styledComponents["default"].div.withConfig({
  displayName: "OverflowControls",
  componentId: "sc-1hsxa6c-2"
})(["pointer-events:none;"]);

var BlueWrapper = (0, _styledComponents["default"])(_offerStyles.WithIconWrapper).withConfig({
  displayName: "BlueWrapper",
  componentId: "sc-1hsxa6c-3"
})(["&&{position:relative;background-color:", ";border-radius:8px;padding:16px;overflow:hidden;min-height:350px;height:", ";@media (", "){min-height:200px;height:", ";}& > ", "{position:absolute;bottom:0;left:0;right:0;}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.bubbleBlue100;
}, function (_ref4) {
  var _ref4$isExpanded = _ref4.isExpanded,
      isExpanded = _ref4$isExpanded === void 0 ? false : _ref4$isExpanded;
  return isExpanded ? 'auto' : '350px';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.forLargerThanPhone;
}, function (_ref6) {
  var _ref6$isExpanded = _ref6.isExpanded,
      isExpanded = _ref6$isExpanded === void 0 ? false : _ref6$isExpanded;
  return isExpanded ? 'auto' : '200px';
}, OverflowControls);

var CopyForward = /*#__PURE__*/_react["default"].forwardRef(function (_ref7, ref) {
  var children = _ref7.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      size: "lg",
      children: children
    })
  });
});

var Description = (0, _styledComponents.withTheme)(function (_ref8) {
  var children = _ref8.children,
      theme = _ref8.theme;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var copyRef = (0, _react.useRef)(null);
  var isOverflowed = (0, _useIsOverflowed.useIsOverflowed)(copyRef);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(BlueWrapper, {
    isExpanded: isExpanded,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
      name: "system/certified-ribbon",
      color: theme.scuttleGray600,
      height: 24,
      width: 24
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CopyForward, {
      size: "lg",
      ref: copyRef,
      children: children
    }), !isExpanded && isOverflowed && /*#__PURE__*/(0, _jsxRuntime.jsxs)(OverflowControls, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FadeOut, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ToggleMoreButton, {
        variation: "noOutline",
        onClick: function onClick() {
          return setIsExpanded(!isExpanded);
        },
        children: ["See More", /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "actions/carrot-down"
        })]
      })]
    })]
  });
});
exports.Description = Description;
//# sourceMappingURL=description.js.map